






















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Surface from '@/components/atoms/Surface/Surface.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';

@Component({ components: { Surface, Typography } })
export default class TableCell extends Vue {
  @Prop({ default: '#193647' }) readonly color?: string;
  @Prop({ default: '16px' }) readonly fontSize?: string;
  @Prop({ default: '20px' }) readonly lineHeight?: string;
  @Prop({ default: '400' }) readonly fontWeight?: string;
  @Prop({ default: 'left' }) readonly textAlign?: string;
  @Prop({ default: '0 32px' }) readonly padding?: string;
  @Prop({ default: '72px' }) readonly height?: string;

  @Emit('click')
  click() {}
}
